module.exports = __webpack_public_path__ + "img/reportChicken_2.f3e94363.png";